import React, { useState, useEffect } from 'react';
import axios from 'axios';
import webservice from '../../../services/webservice';
import { AesDecrypt } from '../../../services/crypto';
import { FaTimes, FaAndroid, FaApple, FaHistory } from 'react-icons/fa';

const AuditLogModal = ({ show, onHide }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('android');

  useEffect(() => {
    if (show) {
      fetchLogs();
    }
  }, [show]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${webservice}api/getRemoteConfigLogs`, {});
      if (response.data.response === 'S') {
        const decryptedData = AesDecrypt(response.data.data);
        if (decryptedData) {
          setLogs(JSON.parse(decryptedData));
        }
      }
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredLogs = logs.filter(log => log.platform === activeTab);

  if (!show) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
      <div style={{ background: '#ffffff', borderRadius: '16px', overflow: 'hidden', border: 'none', width: '100%', maxWidth: '800px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
        <div style={{ padding: '24px 30px', borderBottom: '1px solid #F1F5F9', background: '#F8FAFC', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h4 style={{ margin: 0, fontWeight: '700', color: '#0F172A', fontSize: '20px' }}>Audit Log</h4>
          <FaTimes style={{ cursor: 'pointer', fontSize: '18px', color: '#64748B', transition: 'color 0.2s' }} onClick={onHide} />
        </div>
        <div style={{ padding: '0 30px', background: '#F8FAFC', borderBottom: '1px solid #E2E8F0', display: 'flex', gap: '20px' }}>
          <div
            onClick={() => setActiveTab('android')}
            style={{
              padding: '12px 10px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '14px',
              color: activeTab === 'android' ? '#2563EB' : '#64748B',
              borderBottom: activeTab === 'android' ? '2px solid #2563EB' : '2px solid transparent',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <FaAndroid style={{ marginRight: '6px', fontSize: '16px' }} />
            Android
          </div>
          <div
            onClick={() => setActiveTab('ios')}
            style={{
              padding: '12px 10px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '14px',
              color: activeTab === 'ios' ? '#2563EB' : '#64748B',
              borderBottom: activeTab === 'ios' ? '2px solid #2563EB' : '2px solid transparent',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <FaApple style={{ marginRight: '6px', fontSize: '16px', marginBottom: '2px' }} />
            iOS
          </div>
        </div>

        <div style={{ padding: '20px 30px', maxHeight: '500px', overflowY: 'auto', background: '#FFFFFF' }}>
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : filteredLogs.length > 0 ? (
            filteredLogs.map((log, index) => (
              <div key={index} style={{ marginBottom: '20px', padding: '16px', border: '1px solid #E2E8F0', borderRadius: '12px', background: '#F8FAFC' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', borderBottom: '1px solid #E2E8F0', paddingBottom: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#E0E7FF', color: '#4F46E5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '12px' }}>
                      {log.userId?.charAt(0)?.toUpperCase() || 'A'}
                    </div>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#1E293B' }}>{log.userId || 'Admin'}</div>
                      <div style={{ fontSize: '11px', color: '#64748B' }}>Environment: <span style={{ fontWeight: '600', color: '#475569', textTransform: 'uppercase' }}>{log.environment}</span></div>
                    </div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#64748B', textAlign: 'right' }}>
                    <div>{new Date(log.timestamp).toLocaleDateString()}</div>
                    <div>{new Date(log.timestamp).toLocaleTimeString()}</div>
                  </div>
                </div>

                <div>
                  <h6 style={{ fontSize: '12px', fontWeight: '700', color: '#475569', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Changes Made:</h6>
                  {log.changes && Object.keys(log.changes).length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      {Object.entries(log.changes).map(([key, value]) => (
                        <div key={key} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', padding: '6px 10px', background: '#FFFFFF', borderRadius: '6px', border: '1px solid #F1F5F9' }}>
                          <span style={{ color: '#475569', fontWeight: '500' }}>{key.replace('config.', '')}</span>
                          <span style={{ color: value === 'REMOVED' ? '#EF4444' : '#10B981', fontWeight: '600' }}>
                            {typeof value === 'boolean' ? (value ? 'Active' : 'Off') : (typeof value === 'object' ? JSON.stringify(value) : value)}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: '13px', color: '#94A3B8', fontStyle: 'italic' }}>No specific field changes recorded.</div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#64748B', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <FaHistory style={{ fontSize: '32px', color: '#CBD5E1', marginBottom: '12px' }} />
              <h6 style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#475569' }}>No Logs Found</h6>
              <p style={{ margin: '6px 0 0', fontSize: '13px' }}>There is no audit history for {activeTab === 'android' ? 'Android' : 'iOS'} yet.</p>
            </div>
          )}
        </div>
        <div style={{ padding: '16px 30px', background: '#F8FAFC', borderTop: '1px solid #F1F5F9', textAlign: 'right' }}>
          <button onClick={onHide} style={{ padding: '8px 20px', borderRadius: '8px', background: '#FFFFFF', border: '1px solid #CBD5E1', color: '#475569', fontWeight: '600', fontSize: '13px', cursor: 'pointer', transition: 'all 0.2s' }}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default AuditLogModal;
